var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result"},[_c('h2',[_vm._v("Score: "+_vm._s(_vm.displayScore))]),_c('p',[_vm._v("The development is not finished, for demo only.")])])}
var staticRenderFns = []

export { render, staticRenderFns }